import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/landing/Footer";

export default function LegalPage({ data }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${data.title} · Türkiye Borsa Robotu`;
  }, [data]);

  return (
    <main className="bg-white min-h-screen flex flex-col">
      {/* Top bar */}
      <header className="sticky top-0 z-50 bg-white shadow-[0_4px_20px_rgba(18,58,114,0.08)]">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 h-[68px] flex items-center justify-between">
          <Link to="/" data-testid="legal-brand" className="font-extrabold text-brand text-lg sm:text-xl tracking-tight">
            TÜRKİYE BORSA ROBOTU
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-brand transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Ana Sayfa
          </Link>
        </div>
      </header>

      {/* Hero band */}
      <section className="bg-brand-light border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-12 lg:py-16">
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="font-extrabold text-navy tracking-tight text-3xl sm:text-4xl lg:text-5xl"
          >
            {data.title}
          </motion.h1>
          {data.updated && <p className="text-brand font-semibold mt-3">{data.updated}</p>}
        </div>
      </section>

      {/* Content */}
      <article className="flex-1">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-12 lg:py-16 space-y-9">
          {data.sections.map((s, i) => (
            <motion.section
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.05 }}
            >
              <h2 className="font-bold text-navy text-xl sm:text-2xl mb-3">{s.heading}</h2>
              {s.paragraphs?.map((p, j) => (
                <p key={j} className="text-slate-600 leading-relaxed mb-2">
                  {p}
                </p>
              ))}
              {s.bullets && (
                <ul className="mt-2 space-y-2">
                  {s.bullets.map((b, j) => (
                    <li key={j} className="flex items-start gap-3 text-slate-600">
                      <span className="mt-2 w-1.5 h-1.5 rounded-full bg-brand shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>
              )}
            </motion.section>
          ))}
        </div>
      </article>

      <Footer />
    </main>
  );
}
